import { useEffect, useState, useRef, useContext, createElement } from 'react';
import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';
import { LoginOTP } from './LoginOTP';
import {
    LoginMenu,
    TimeOutWarnDialog,
    ComingSoonLogoutDialog, FootballInplayMsgDialog
} from './LoginMenu';
import LoginLoading from '../Common/ui-components/LoginLoading';
import { LoginAccountInfo, UserInfo, LogoutSuccessMsg, LoginIncorrect, LogoutReminder } from './LoginBase';
import { ConfirmationHeader, PanelAlupTemplate, BSPanelConfirmationTitle, ResendDoneDialog, OddsUpdatedAcceptCheckbox, TCErrorPopup, PcardPanel } from './BetSlipBase';
import { FBBetLineTemplate, HRBetLineTemplate, M6BetLineTemplate } from './BetLineTemplate';
import { getSessionLoginAccount, isLogonHigh } from './LoginHooks';
import { NewWindow, MaxOnePopupWindow, isEWinPage } from '../Common/home-common';
import bgMusic from '../../info/Include/Exclamation.wav';
import { useBetSlip, getBalanceValue } from './BetSlipHooks';
import { SetLoginBusyStatus } from './LoginHooks';
import { ConfigContext, QueryConfig, GetBetslipConfig } from '../Common/ConfigHelper';
import useBroadcastChannel from '../Common/hooks/useBroadcastChannel';
import { GlobalContext } from '../../contexts/GlobalContext';
import { glassboxCustomEvent } from '../Common/utils/glassbox';
import { getWebIDHashed } from '../Common/utils/adobeLaunch';
import { textFormatAmountFn, isEoD } from '../Common/GlobalFunc';
import { initSsoLogin, setSsoLogout, isSsoLogin, useSSOExpiryCheckOnFocus, useActivateUser } from './SsoHook';
import useBetSlipPush from './useBetSlipPush';

import { Scrollbars } from 'react-custom-scrollbars-2';
import { callLogoutIbApi, clearLoginSessionStorage, getWhitelistAcc } from './LoginIBHooks';
import { SurveyInBetSlip } from '../Header/Survey';
import { compressToUTF16, decompressFromUTF16 } from 'lz-string';
import { EarlySettlementShortcutNavigate } from '../Common/ui-components/EarlySettlementShortcutNavigate';
import { GetError } from '../Common/bs_str_table';
import { ReactComponent as ArrowIcon } from '../../info/Include/images/arrow-down.svg';
import { useNavigate } from "react-router-dom";
import { betTypeConversionPage } from '../Racing/Common/Common';

import { useWindowSize, delay, timeoutPromise } from '../Common/CommonHooks';
import { TCModal } from './TandCModal';
import clsx from 'clsx';
import { TrustBrowser } from './TrustBrowser';
import ErrorPopup from './ErrorPopup';
import LoginErrorPopup from './LoginErrorPopup';
import { MissingMobile } from './MissingMobile';
import { getEwinEoD, setWinPointsEnable } from './BetSlipIBAPI';
import { useAdobeLaunch } from '../Common/utils/adobeLaunch';
import usePreviewBetAcceptance from './usePreviewBetAcceptance';
import LoginPassKey from './LoginPassKey';
import { SecurityPin } from './SecurityPin';
import groupBy from 'lodash/groupBy';
import LogoutReminderPopup from '../Common/ui-components/LogoutReminderPopup';
import { LogoutReminderPopupType } from '../Common/constants';
import { getDeleteBetSlipAdobeEventData, getTransactionPreviewBetSlipAdobeEventData } from '../Common/utils/eCommerceEvent';

const CustomScrollbars = (props) => (
    <div style={{ flex: 1 }} className="betSlipScrollBars">
        <Scrollbars
            style={{ height: '100%' }}
            autoHeight={false}
            {...props} 
            renderView={(props)=>{
                return createElement(
                    'div',
                    {...props, 'data-testid': 'bet_placeBetList_scrollView'}
                );
            }}
        />
    </div>
);

const BetSlip = ({ product, useLoginLogout, useLoginLogoutFR, login_shared_states }) => {
    const { t, i18n } = useTranslation();
    const globalContext = useContext(GlobalContext);
    const configContext = useContext(ConfigContext);
    const bsConfig = GetBetslipConfig();
    const lang = i18n.language;
    const speedbetBasket = window.globalConfig.SPEEDBET_BASKET;
    const printRef = useRef();
    const pcardAccount = getSessionLoginAccount();
    const cashoutIP = globalContext.cashoutInProcess ? 'cashoutInProcess' : '';
    const [isUsernameReadOnly, setIsUsernameReadOnly] = useState(false);
    const [isPwdReadOnly, setIsPwdReadOnly] = useState(false);
    const [isLoadTNCText, setIsLoadTNCText] = useState(false);
    const [FTInplayDialogDelay, setFTInplayDialogDelay] = useState(0);
    const [showOverlay, setShowOverlay] = useState(false);
    const [isCollapse, setIsCollapse] = useState(false);
    const [otp, setOtp] = useState('');
    const [pin, setPin] = useState('');
    const clearBetSlipOnUserStateChangeRef = useRef();
    const lastAccessTokenChangeIsLoginRef = useRef();
    const navigate = useNavigate();

    const { isMobileSize } = useWindowSize();
    const [isOnWhitelist, setIsOnWhiteList] = useState(false);
    const {
        updateBetSlipOnUserStateChangeRef,
        clearBetSlip,
        betBaskets,
        setBetBaskets,
        panelAllupObj,
        isShowPreviewInfo,
        setIsShowPreviewInfo,
        resetPanelAllupFn,
        isShowFTInplayDialog,
        setIsShowFTInplayDialog,
        panelAllupCheckFn,
        updateBetTotal,
        getBetTotal,
        getNumberOfBetlines,
        isShowError,
        setIsShowError,
        panelAllupData,
        setPanelAllupData,
        currentBasket,
        setCurrentBasket,
        clearCurrentBasket,
        sendBetRequest,
        isShowConfirmation,
        setIsShowConfirmation,
        betDoneFn,
        resendBetDoneFn,
        sendBetTime,
        confirmationStatus,
        balance,
        setBalance,
        disabledResendBtn,
        isSpeedbet,
        setIsSpeedbet,
        sendBetAPILoading,
        betBaskets_0,
        computePanelAllupFunc,
        firstTimeFromJCRWRedirect,
        disablePreviewConfirm,
        setDisablePreviewConfirm
    } = useBetSlip();

    const isPreviewPage = isShowPreviewInfo && !isShowConfirmation;

    const {
        initPreviewBetAcceptanceState,
        resetPreviewBetAcceptanceState,
        showAcceptAllCheckbox,
        isAcceptAllChange,
        toggleAcceptAllChange,
        onPreviewBetAcceptanceClick
    } = usePreviewBetAcceptance({
        isPreview: isPreviewPage && window.globalConfig.BS_PREVIEW_DATA_REFRESH
    });

    const {
        checkAccountPwd,
        loginAccount,
        setLoginAccount,
        resetLoginTimeout,
        accessToken,
        logoutStateFn,
        loginTimeoutRemind,
        isShowTODialog,
        setIsShowTODialog,
        isShowCSLogoutDialog,
        setIsShowCSLogoutDialog,
        logoutReminderPopupState,
        setLogoutReminderPopupState,
        isShowTandC,
        setIsShowTandC,
        userInfo,
        showUserInfo,
        setShowUserInfo,
        showLastLoginInfo,
        setShowLastLoginInfo,
        showAnswerErrorMsg,
        showLogoutSucMsg,
        setShowLogoutSucMsg,
        isShowLogoutBetText,
        setIsShowLogoutBetText,
        willOpenUrl,
        setWillOpenUrl,
        showLogoutReminder,
        setShowLogoutReminder,
        LoginAPILoading,
        setLoginAPILoading,
        showEwalletDialog,
        setShowEwalletDialog,
        sessionIdleTimeRef,
        warningIdleTimeRef,
        warningIdleTimeRef2,
        loginHigh,
        setUserActive
    } = useLoginLogout;

    const {
        FR_loginWithUsernamePassword,
        FR_loginWithOTP,
        FR_loginWithPIN,
        FR_initStep,
        FR_TurstBrowser,
        FR_GetToken,
        FR_Logout,
        isShowOTPAuth,
        setIsShowOTPAuth,
        isShowSecurityPinAuth,
        setIsShowSecurityPinAuth,
        isShowOTPToast,
        setIsShowOTPToast,
        invalidOTP,
        setInvalidOTP,
        invalidPIN,
        setInvalidPIN,
        setIsShowTrustBrowser,
        isShowTrustBrowser,
        FR_GetMobile,
        FR_ResendOTP,
        showErrorPopup,
        setShowErrorPopup,
        showLoginLockPopup,
        setShowLoginLockPopup,
        setLoginIncorrectMsg,
        isMissingMobile,
        setIsMissingMobile,
        isVoiceOTP, 
        setIsVoiceOTP,
        refreshToken,
        isPassKeyRegConsent,
        setIsPassKeyRegConsent,
        FR_passKeyBindProcess,
        isPassKeyRegSuccess,
        setIsPassKeyRegSuccess,
        FR_passKeySuccess
    } = useLoginLogoutFR;

    const { pwd, setPwd, loginIncorrectMsg, closeLoginIncorrectMsg } = login_shared_states;
    const { isShowPcardPanel, setIsShowPcardPanel, openCWL, setCwlPage, cwlPage } = globalContext;
    const isPriorityLoginRef = useRef(false);
    const [showTCErrorPopup, setShowTCErrorPopup] = useState(false);
    const showLPEntry = sessionStorage.getItem('enableEwinLP') === '1' && sessionStorage.getItem('enableWinPoints') === '1' && globalContext?.globalState?.commonCtrl?.WhitelistedCustomerOnlyButton === false && window.globalConfig.IS_EWIN2 === false;

    const { sendAdobeEvent } = useAdobeLaunch();
    const [loadingStepOne, setLoadingStepOne] =useState(false)
    const [verifyOtpLoading, setVerifyOtpLoading] =useState(false)
    const [verifyPinLoading, setVerifyPinLoading] =useState(false)
    const [isSecurityPin, setIsSecurityPin] = useState(false);
    useEffect(() => {
        // re-init for OTP overlay
        setOtp('');
        setInvalidOTP(false);
    }, [isShowOTPAuth]);

    useEffect(() => {
        // re-init for OTP overlay
        setPin('');
        setInvalidPIN(false);
        if(isShowSecurityPinAuth){
            setIsSecurityPin(true);
        }
    }, [isShowSecurityPinAuth]);

    useBetSlipPush({
        disableDataRefresh: window.globalConfig.BS_PREVIEW_DATA_REFRESH
            ? isShowConfirmation || sendBetAPILoading
            : isShowPreviewInfo,
        computePanelAllupFunc
    });

    window.isReallyShowPreviewInfoTab = isShowPreviewInfo && !isShowConfirmation

    // const ciamInit = async () => {
    //     try {
    //         const token = await FR_GetToken();
    //         console.log("Arkle", token)
    //         const userObj = jwtDecode(token)  
    //         console.log(userObj)
    //         handleInpuUserName(userObj?.webId)
    //         } catch {
    //             console.log("Arkle not login");
    //         }
    // }

    // const handleInpuUserName = (data) => {
    //     if (
    //         window.racingConfig['redirectIsReplaceWindow'] &&
    //         /* document.referrer.indexOf(window.globalConfig.JCRW_URL) > -1 && */
    //         firstTimeFromJCRWRedirect == 'true'
    //     ) {
    //         SetLoginBusyStatus(true);
    //         const islogon_b4redirect = sessionStorage.getItem('is_logon');

    //         const sso_sign_in_level = data ? sessionStorage.getItem('sso_sign_in_level') : 0;

    //         console.debug(islogon_b4redirect, sso_sign_in_level);
    //         if (islogon_b4redirect == 1 && sso_sign_in_level == 2) {
    //             // logged in b4 redirect and sso is still 2
    //             loginHigh();
    //             console.log('ssoInit loginHigh')
    //         }else if (sso_sign_in_level > 0) {
    //             console.debug('11 handleInpuUserName')
    //             clearLoginSessionStorage();
    //             setLoginAccount(data);
    //             setIsUsernameReadOnly(true);
    //         } else {
    //             console.debug('11 handleInpuUserName')
    //             clearLoginSessionStorage();
    //             setIsUsernameReadOnly(false);
    //             setIsPwdReadOnly(false);
    //         }
    //         if (islogon_b4redirect == sessionStorage.getItem('is_logon')) {
    //             // set betbaskets
    //             const raw = betBaskets_0;
    //             console.debug('redirect from jcrw, setting betbasket...');
    //             if (raw) {
    //                 const betBasketsObj = JSON.parse(decompressFromUTF16(betBaskets_0));
    //                 setBetBaskets(betBasketsObj);
    //                 console.debug('betBasketsObj', betBasketsObj);
    //             }
    //         }
    //         sessionStorage.setItem('1stTimeFromJCRWRedirect', false);
    //         SetLoginBusyStatus(false);
    //     } else {
    //         console.debug('no JCRW redirect')
    //         // disabled JCRW redirect
    //         if (!!data) {
    //             console.log('input', data)
    //             setLoginAccount(data);
    //             setIsUsernameReadOnly(true);
    //         } else {
    //             setIsUsernameReadOnly(false);
    //             setIsPwdReadOnly(false);
    //         }
    //     }
    // }

    const ssoInit = async () => {
        if (
            window.racingConfig['redirectIsReplaceWindow'] &&
            /* document.referrer.indexOf(window.globalConfig.JCRW_URL) > -1 && */
            firstTimeFromJCRWRedirect == 'true'
        ) {
            // JCRW redirect
            SetLoginBusyStatus(true);
            const islogon_b4redirect = sessionStorage.getItem('is_logon');
            const ssoGuid = sessionStorage.getItem('sso_guid');
            const data = await initSsoLogin();

            const ssoGuid2 = sessionStorage.getItem('sso_guid');
            const sso_sign_in_level = ssoGuid === ssoGuid2 ? sessionStorage.getItem('sso_sign_in_level') : 0;

            console.debug(islogon_b4redirect, sso_sign_in_level);
            if (islogon_b4redirect == 1 && sso_sign_in_level == 2) {
                // logged in b4 redirect and sso is still 2
                loginHigh();
                console.debug('ssoInit loginHigh');
            } else if (sso_sign_in_level > 0) {
                clearLoginSessionStorage();
                setLoginAccount(data);
                if (window.globalConfig.NEW_CIAM == window.CiamFlag.UseCiam) {
                    setPwd('********');
                    setIsPwdReadOnly(true);
                }
                setLoginAccount(data);
                setIsUsernameReadOnly(true);
                console.debug('ssoInit sso_sign_in_level > 0', data);
            } else {
                clearLoginSessionStorage();
                setIsUsernameReadOnly(false);
                setIsPwdReadOnly(false);
                console.debug('ssoInit sso_sign_in_level 0');
            }
            if (islogon_b4redirect == sessionStorage.getItem('is_logon')) {
                // set betbaskets
                const raw = betBaskets_0;
                console.debug('redirect from jcrw, setting betbasket...');
                if (raw) {
                    const betBasketsObj = JSON.parse(decompressFromUTF16(betBaskets_0));
                    setBetBaskets(betBasketsObj);
                    console.debug('betBasketsObj', betBasketsObj);
                }
            }
            sessionStorage.setItem('1stTimeFromJCRWRedirect', false);
            SetLoginBusyStatus(false);
        } else {
            console.debug('no JCRW redirect');
            // disabled JCRW redirect
            const data = await initSsoLogin();
            if (data != false) {
                setLoginAccount(data);
                if (window.globalConfig.NEW_CIAM == window.CiamFlag.UseCiam) {
                    setPwd('********');
                    setIsPwdReadOnly(true);
                }
                setIsUsernameReadOnly(true);
            } else {
                setIsUsernameReadOnly(false);
                setIsPwdReadOnly(false);
            }
        }
    };

    useEffect( () => {
        console.debug("Arkle start")
        // ciamInit()
        
        ssoInit();
        
        // .then(() => {
        //     if(!isSsoLogin()){
        //         FR_Logout().then(FR_initStep);
        //     }
        // });
        updateBetSlipOnUserStateChangeRef.current?.();

        // clear CIAM cookie if not SSO login
        //FR_Logout().then(FR_initStep);
    }, []);

    useEffect(() => {
        if (accessToken  || betBaskets[currentBasket]?.length > 0) {
            window.addEventListener('beforeunload', window.secDialogFn);
            window.addEventListener('unload', unloadEvent);
        } else {
            window.removeEventListener('beforeunload', window.secDialogFn);
        }
        return () => {
            window.removeEventListener('beforeunload', window.secDialogFn);
        };
    }, [accessToken, betBaskets]);

    useEffect(() => {
        let state = globalContext.globalState.betslipState;
        if (isShowTandC) {
            state = bsConfig?.betslipState.NORMAL || 0;
            globalContext.globalRef.current.enableESButton = false;
        } else if (
            !window.globalConfig.NEW_LOGOUT_REMINDER_FLOW && isShowTODialog 
            || window.globalConfig.NEW_LOGOUT_REMINDER_FLOW && logoutReminderPopupState === LogoutReminderPopupType.warning
        ) {
            state = bsConfig?.betslipState.IDLEALERT || 0;
        } else if (isShowPreviewInfo) {
            state = bsConfig?.betslipState.PREVIEWBET || 0;
        } else {
            state = bsConfig?.betslipState.NORMAL || 0;
        }
        globalContext.updateGlobalState({ betslipState: state });
    }, [isShowTandC, isShowTODialog, isShowPreviewInfo, logoutReminderPopupState]);

    useEffect(() => {}, [globalContext.globalState.betslipState]);

    const unloadEvent = (e) => {
        MaxOnePopupWindow(true);
        if (window.popupWindow && !window.popupWindow.closed) {
            window.popupWindow.close();
        }
    };

    useEffect(() => {
        updateBetTotal(
            betBaskets,
            isPreviewPage && window.globalConfig.BS_PREVIEW_DATA_REFRESH
        );
    }, [betBaskets, product, currentBasket, isPreviewPage]);

    useEffect(() => {}, [isShowError]);

    useEffect(() => {
        if (isShowPreviewInfo && betBaskets[currentBasket].length === 0) {
            backBetlines();
        }
    }, [betBaskets, isShowPreviewInfo]);

    useEffect(() => {
        if (window.racingConfig['redirectIsReplaceWindow']) {
            // filter out successful bet in betBaskets
            let filtered_betBaskets = betBaskets.map((basket) =>
                basket.filter((bet) => !(bet.resultCode === 0 && bet.isCounterOffer == false))
            );
            sessionStorage.setItem('betBaskets_0', compressToUTF16(JSON.stringify(filtered_betBaskets)));
            console.debug('setting betBaskbets for jcrw redirect', filtered_betBaskets);
        }
    }, [betBaskets]);

    useEffect(() => {
        if (sessionStorage.getItem('access_token') == '') {
            setLogoutUI(false, true);
        }
        if (sessionStorage.getItem('access_token') == null) {
            setLogoutUI(false, false);
        }
        clearBetSlipOnUserStateChangeRef.current();
    }, [sessionStorage.getItem('access_token'), accessToken]);

    clearBetSlipOnUserStateChangeRef.current = () => {
        const currentIsLogin = isLogonHigh();
        if ((window.globalConfig.IS_EWIN2 || window.globalConfig.IS_SPEEDBET) && currentIsLogin && !lastAccessTokenChangeIsLoginRef.current) {
            const lastLoginAccount = sessionStorage.getItem('last_login_account');
            const currentAccount = sessionStorage.getItem('account') || loginAccount;
            if (currentAccount !== lastLoginAccount) {
                setTimeout(() => clearBetSlip(), 0);
            };
            sessionStorage.setItem('last_login_account', currentAccount);
        }
        lastAccessTokenChangeIsLoginRef.current = currentIsLogin;
    };

    useEffect(() => {
        setWinPointsEnable();
    }, []);

    useEffect(() => {
        if (accessToken) {
            isPriorityLoginRef.current = isShowPcardPanel && showLPEntry ? true : false;
            sessionStorage.setItem('PriorityLogin', isShowPcardPanel && showLPEntry ? '1': '0');
            setIsShowPcardPanel(false);
            setShowOverlay(false);
            document.getElementById('divBetSlipNormal').classList.remove('pcard-active');
        }
    }, [accessToken]);

    useEffect(() => {
        checkIsEod();
    }, [sessionStorage.getItem('OOSMsgId')]);

    const onClickOverlay = () => {
        // if (window.screen.width > 559) { why ? cause SQ0248-1589
        // } else {
        setIsShowPcardPanel(false);
        document.getElementById('divBetSlipNormal').style.left = '105vw';
        document.getElementById('betslip-over-lay').style.left = '105vw';
        document.body.style.overflow = null;
        const element = document.querySelector('.bottom-menu');
        if(element) {
            element.style.zIndex = null;
        }

        setTimeout(function () {
            document.getElementById('betslip-container').style.display = 'none';
            document.getElementById('divBetSlipNormal').classList.remove('pcard-active');
        }, 300);
        // }
    };

    const onClickOverlay2 = () => {
        setIsShowPcardPanel(false);
        setShowOverlay(false);
        setCwlPage('');
    };

    useEffect(() => {
        if (!isMobileSize && document.getElementById('divBetSlipNormal').style.left) {
            document.getElementById('divBetSlipNormal').style.left = null;
            document.getElementById('betslip-over-lay').style.left = null;
            document.body.style.overflow = null;
            const element = document.querySelector('.bottom-menu');
            if(element)  element.style.zIndex = null;
            document.getElementById('betslip-container').style.display = null;
        }
    }, [isMobileSize]);

    const onInputLoginAccount = (e) => {
        let val = e.target.value;
        if (isMobileSize && e.target.getAttribute('data-init') == 1) {
            if (e.nativeEvent.data != null) {
                val = e.nativeEvent.data;
            }
            e.target.setAttribute('data-init', 0);
        }
        setLoginAccount(val);
    };

    const onInputPassword = (e) => {
        let val = e.target.value;
        if (isMobileSize && e.target.getAttribute('data-init') == 1) {
            if (e.nativeEvent.data != null) {
                val = e.nativeEvent.data;
            }
            e.target.setAttribute('data-init', 0);
        }
        setPwd(val);
    };

    const loginInputFocus = (e, type) => {
        if (isMobileSize) {
            e.preventDefault();
            e.target.setAttribute('data-init', 1);
            e.target.setSelectionRange(10, 10);
            setTimeout(function () {
                e.target.setSelectionRange(10, 10);
            });
        }
        document.getElementById(type).setAttribute('placeholder', '');
    };
    const loginInputBlur = (type) => {
        document
            .getElementById(type)
            .setAttribute(
                'placeholder',
                type === 'login-account-input'
                    ? t('LB_BS_LOGIN_ACCOUNT_PLACEHOLDER')
                    : t('LB_BS_LOGIN_PASSWORD_PLACEHOLDER')
            );
    };
    const goToFAQFn = () => {
        let url = t('LB_BS_LOGIN_FAQ_URL');
        NewWindow(url, '', 800, 640, 1, 1);
    };
    useEffect(() => {
        console.debug('isread', isUsernameReadOnly);
    }, [isUsernameReadOnly]);
    const ssoExpired = async (ssoLastExtendError = 'SSO_SIGN_OUT_PASSIVE', showAlert = true) => {
        const isSSO = await isSsoLogin();
        if (!isSSO) {
            setIsUsernameReadOnly(false);
            setIsPwdReadOnly(false);
            setLoginAccount('');
            setLogoutUI(false, false);
            setSsoLogout();
        } else {
            setLogoutUI(false, false);
            // ciamInit();
            ssoInit();
        }
        setPwd('');

        console.debug('11 ssoExpired')
        clearLoginSessionStorage();

        if (showAlert) {
            let errorText = t('LB_BS_' + ssoLastExtendError);
            if (window.globalConfig.RETAIN_BETS_IN_BET_SLIP_ON_LOGOUT && i18n.exists('NEW_LB_BS_' + ssoLastExtendError)) {
                errorText = t('NEW_LB_BS_' + ssoLastExtendError);
            }
            window.alert(errorText);
        }
    };

    // otp overlay click Cancel
    const onClickCancelOTP = () => {
        const ssoWebId = window.sessionStorage.getItem('sso_web_id');
        setLoginAccount(ssoWebId ? ssoWebId : '');
        setPwd('');
        setIsUsernameReadOnly(ssoWebId? true : false);
        setIsPwdReadOnly(false);
        setIsShowOTPAuth(false);
        //FR_initStep();
        if (isMissingMobile) setIsMissingMobile(false);
    };

    const onClickCancelSecurityPin = () => {
        const ssoWebId = window.sessionStorage.getItem('sso_web_id');
        setLoginAccount(ssoWebId ? ssoWebId : '');
        setPwd('');
        setIsUsernameReadOnly(ssoWebId? true : false);
        setIsPwdReadOnly(false);
        setIsShowSecurityPinAuth(false);
    };

    const onClickCancelErrorPopup = (errorType) => {
        if (errorType == 'session timeout' || errorType == '100021') {
            const ssoWebId = window.sessionStorage.getItem('sso_web_id');
            setLoginAccount(ssoWebId ? ssoWebId : '');
            setPwd('');
            setIsShowOTPAuth(false);
            setIsShowSecurityPinAuth(false);
            setIsShowTrustBrowser(false);
        }
        setShowErrorPopup(false);
    };

    const onClickCancelLoginLockPopup = () => {
        const ssoWebId = window.sessionStorage.getItem('sso_web_id');
        setLoginAccount(ssoWebId ? ssoWebId : '');
        setPwd('');
        setIsShowOTPAuth(false);
        setIsShowSecurityPinAuth(false);
        setShowLoginLockPopup(false);
        closeLoginIncorrectMsg();
        FR_initStep();
    };

    const onClickCancelPassKey = () => {
        
        FR_initStep();
        setIsPassKeyRegConsent(false);
    }

    const onClickPassKeyBind = (isBindPassKey) => {
        FR_passKeyBindProcess(isBindPassKey);
        // setIsPassKeyRegSuccess(true)
    }

    const onClickRegSuccess = async () => {
        setIsPassKeyRegSuccess(false);
        await FR_passKeySuccess();
    }
    const handleClickSignIn = async () => {
        if(!navigator.onLine){
            setShowErrorPopup('network');
            setPwd('');
            return
        }

        let loginAccountTrim = loginAccount.trim();
        setLoginAccount(loginAccountTrim);
        setLoginAPILoading(true);
        setLoadingStepOne(true);

        try {
            //check txn for EoD status if use Arkle, continue only if not EoD
            if (window.globalConfig.NEW_CIAM != window.CiamFlag.UseCiam) {
                const eodResult = await getEwinEoD(loginAccountTrim);
                const bypassCode = eodResult?.bypassEodCode;

                 //remove bypass code before Arkle login
                if (!!bypassCode) {
                    loginAccountTrim = loginAccountTrim.replace(bypassCode, '');
                    setLoginAccount(loginAccountTrim.replace(bypassCode, ''));
                }

                if (eodResult.isEoD != 'False') {
                    setLoginAccount('');
                    setEodUi();
                    return;
                }
            }
            
            let eod = await Promise.race([checkIsEodAsync(), timeoutPromise()]);
            // if (!(await checkIsEodAsync())) {
            if (!eod) {
                const accessToken = sessionStorage.getItem('access_token');
                if (
                    window.globalConfig.NEW_CIAM == window.CiamFlag.UseWhitelist ||
                    window.globalConfig.NEW_CIAM == window.CiamFlag.UseArkle
                ) {
                    await loginWithNewCIAM(loginAccountTrim, pwd);
                } else {
                    await checkAccountPwd(loginAccountTrim, pwd);
                }
            }
        } catch (err) {
            console.debug(err);
            if (err.message === 'Request timed out') {
                setLoginIncorrectMsg('TIMEOUT');
            } else {
                setLoginIncorrectMsg('OTHER');
            }
        }
        setLoadingStepOne(false);
        setLoginAPILoading(false);
    };

    const loginWithNewCIAM = async (loginAccount, password) => {
        // has empty
        if (!loginAccount || !password) {
            setLoginIncorrectMsg('100001');
            //loginStatus.isBusy = false;
            return;
        }

        window.sessionStorage.setItem('LoginWA', 'eWin_login');
        let isOnWhitelist;        

        if (window.globalConfig.NEW_CIAM == window.CiamFlag.UseWhitelist) {
            isOnWhitelist = await getWhitelistAcc(loginAccount);
        } else {
            isOnWhitelist = true; //No need to call whitelist and set to true
        }

       

        setIsOnWhiteList(isOnWhitelist);
        // let isLoginSussess = false;
        if (isOnWhitelist === 'TIMEOUT') {
            console.debug('whitelist timeout, use ekba');
            //use ekba login if whitelist timeout
            window.sessionStorage.setItem('LoginWA', sessionStorage.getItem('LoginWA') + '_non-whitelist');
            await checkAccountPwd(loginAccount, password, false);
            //setLoginIncorrectMsg('TIMEOUT');
            //return;
        }
        if (isOnWhitelist) {
            window.sessionStorage.setItem('LoginWA', sessionStorage.getItem('LoginWA') + '_whitelist');
            const result = await FR_loginWithUsernamePassword(loginAccount, password);
            if (result == 'logout') {
                ssoExpired('SSO_SIGN_OUT_PASSIVE', true);
            }
        } else {
            window.sessionStorage.setItem('LoginWA', sessionStorage.getItem('LoginWA') + '_non-whitelist');
            //const isSSO = await isSsoLogin();
            //if(isSSO) {
            //    await showEkbaQuestion(true);
            //} else {
            //no need to check sso, customer always need to enter password
            await checkAccountPwd(loginAccount, password, false);
            //}
        }
    };

    const handleClickLogout = () => {
        sessionStorage.setItem('setShowLogoutReminder', true);
        setShowLogoutReminder(true);
    };
    const calcTimeOutLogout = () => {
        setLogoutUI(true, true);
    };

    const loginOtherAccountLogout = async () => {
        await setLogoutUI(true, false);
        closeLoginIncorrectMsg();
    };

    const handleClickResendBtn = () => {
        resetLoginTimeout(false);
        if (window.globalConfig.BS_PREVIEW_DATA_REFRESH) {
            const newCurrentBasketData = initPreviewBetAcceptanceState();
            resendBetDoneFn(newCurrentBasketData);
        } else {
            resendBetDoneFn();
        }
        sendTransactionPreviewBetSlipAdobeEvent();
    };

    const closeCandTFn = () => {
        setIsShowTandC(false);
        globalContext.globalRef.current.enableESButton = true;
        if (accessToken) {
            // setShowLastLoginInfo(true)
            // setShowUserInfo(false)
            // setTimeout(() => {
            //     setShowLastLoginInfo(false)
            //     setShowUserInfo(true)
            // }, 5000)
            setShowUserInfo(true);
            setPwd('');
            setLoginAccount('');
        }
    };
    const closeTandCFn = () => {
        setIsShowTandC(false);
        globalContext.globalRef.current.enableESButton = true;
    };
    const closeTOdialogFn = () => {
        setIsShowTODialog(false);
    };

    const closeCSLogoutdialogFn = () => {
        setIsShowCSLogoutDialog(false);
        if (loginTimeoutRemind === '3') {
            logoutStateFn();
            sessionStorage.removeItem('customerSegment');
            sessionStorage.removeItem('hWebID');
            sessionStorage.removeItem('customerHash');
        } else if ((loginTimeoutRemind === '1' || loginTimeoutRemind === '2') && isMobileSize) {
            document.getElementById('betslip-container').style.display = 'inherit';
            document.getElementById('divBetSlipNormal').style.left = 'calc(100vw - 90vw)';
            document.getElementById('betslip-over-lay').style.left = '0';
            // document.body.style.overflow = "hidden";
        }
    };

    const handleLogoutReminderPopupClose = (e) => {
        e.stopPropagation();
        if (logoutReminderPopupState === LogoutReminderPopupType.timeout) {
            logoutStateFn();
            sessionStorage.removeItem('customerSegment');
            sessionStorage.removeItem('hWebID');
            sessionStorage.removeItem('customerHash');
        }

        setLogoutReminderPopupState(LogoutReminderPopupType.closed);
    };

    const highSecurityLogout = () => {
        setLoginAccount(sessionStorage.getItem('sso_web_id'));
        if (window.globalConfig.NEW_CIAM == window.CiamFlag.UseCiam) {
            setPwd('********');
            setIsPwdReadOnly(true);
        }
        setIsUsernameReadOnly(true);
        glassboxCustomEvent('High_Security_Logout', getWebIDHashed());
        console.debug('loginmenu')
        logoutStateFn();
        clearLoginSessionStorage();
        globalContext.esHook.clearEsStateAll();
    };

    const onClickCheckOTP = async () => {
        // loading
        // pop success or error message
        setVerifyOtpLoading(true)
        // reset state with async await
        try {
            let isEod = await Promise.race([checkIsEod(), timeoutPromise()]);
            // const isEod = await checkIsEod();
            //isshownewekba
            if (!isEod) {
                setInvalidOTP('');
                await delay(1);
                await FR_loginWithOTP(otp);
            }
        } catch (err) {
            console.debug(err);
            if (err.message === 'Request timed out') {
                setLoginIncorrectMsg('TIMEOUT');
            } else {
                setLoginIncorrectMsg('OTHER');
            }
        }
        setVerifyOtpLoading(false)
    };

    const onClickCheckPin = async () => {
        // loading
        // pop success or error message
        setVerifyPinLoading(true)
        // reset state with async await
        try {
            setInvalidPIN('');
            await delay(1);
            await FR_loginWithPIN(pin);
            
        } catch (err) {
            console.debug(err);
            if (err.message === 'Request timed out') {
                setLoginIncorrectMsg('TIMEOUT');
            } else {
                setLoginIncorrectMsg('OTHER');
            }
        }
        setVerifyPinLoading(false)
    };

    const onCancelLogout = () => {
        setShowLogoutReminder(false);
        setIsShowLogoutBetText(false);
    };

    const onConfirmLogout = async () => {
        if(window.globalConfig.IS_SPEEDBET || window.globalConfig.IS_EWIN2) {
            document.body.style.overflow = null;
        }

        sendAdobeEvent({ event: 'interaction', interaction: { eventID: 'betlogoutbox-home-box' } });

        await setLogoutUI(true, true);

        setShowLogoutReminder(false);
        if (isShowLogoutBetText) {
            goToNewWindow();
        } else {
            setShowLogoutSucMsg(true);
        }
        await setLogoutUI(true, true);

        await FR_Logout(); //.then(FR_initStep);

     

        glassboxCustomEvent('Logout_OK_button');
    };

    const setLogoutUI = async (isCallLogoutApi, isShowLogoutReminder) => {
        updateBetSlipOnUserStateChangeRef.current?.();
        setShowLogoutReminder(isShowLogoutReminder);
        closeCandTFn();
        setIsShowConfirmation(false);
        isShowTODialog && closeTOdialogFn();
        if (isCallLogoutApi) {
            try {
                await callLogoutIbApi();
                clearLoginSessionStorage();
                ssoExpired('', false);
            } catch (error) {
                console.error(error)
            }
            setIsUsernameReadOnly(false);
            setIsPwdReadOnly(false);
        }
        logoutStateFn();
        globalContext.esHook.clearEsStateAll();
        setIsSpeedbet(window.globalConfig.IS_SPEEDBET);
    };

    const handleClickMenuItem = async (data) => {
        let url = lang === 'en' ? data.uE : data.uC;
        if(data.nE == 'Change Online Password'){
            window.goWcipPage=true;
        }
        if (data.secConfirm && data.secConfirm === '1') {
            const flag = window.confirm(t('LB_BS_LOGIN_FORGOT_ANSWER_MSG'));
            if (flag) {
                window.location.href = url;
            }
        } else {
            if (data.pu == '0') {
                window.location.href = url;
            } else {
                const w = data.w ? Math.min(data.w, window.innerWidth) : Math.min(800, window.innerWidth);
                const h = data.h ? data.h : window.innerWidth > 768 ? 600 : window.innerHeight;
                if (url.indexOf('acctstmt') > -1 || url.indexOf('eft') > -1) {
                    MaxOnePopupWindow(false, url, url.indexOf('acctstmt') > -1 ? 'acctstmt' : 'eft', w, h, 1, 1);
                } else {
                    NewWindow(url, 'betslip', w, h, 1, 1);
                }
            }
        }
    };

    const goToNewWindow = () => {
        NewWindow(willOpenUrl, '', 800, 640, 1, 1);
        setIsShowLogoutBetText(false);
    };

    const resetMyBetSlipLoginInfo = (obj) => {};

    const hasBetlines = () => {
        return betBaskets[currentBasket].length > 0;
    };

    const canSendBet = (betLines) => {
        if (accessToken !== null && accessToken?.length > 0) {
            return betBaskets[currentBasket].filter((item) => !item.betObj.isStopSell).length > 0;
        }
        return false;
    };

    const sendTransactionPreviewBetSlipAdobeEvent = () => {
        const previewDisplayBets = betBaskets[currentBasket].filter((item) => {
            if (item.prod === 'FB') {
                return checkFBBetLineCanDisplay(item);
            }
            return true;
        });

        const transactionPreviewBetSlipEventData = getTransactionPreviewBetSlipAdobeEventData(previewDisplayBets);
        if (transactionPreviewBetSlipEventData) {
            sendAdobeEvent(transactionPreviewBetSlipEventData);
        }
    };

    const gotoPreview = async () => {
        // stay next trigger behaviour
        // const ssoLogoutCheck = await checkSsoStatusFn(true);
        // if(ssoLogoutCheck){
        //     return ;
        // }
        if (window.globalConfig.BS_PREVIEW_DATA_REFRESH) {
            initPreviewBetAcceptanceState();
        }
        
        resetLoginTimeout(false);

        const selectedBetProducts = [...new Set(betBaskets[currentBasket].map(({ betObj: { prod } }) => prod))];

        const betsGroupByRaceSimModeAndBetType = groupBy(betBaskets[currentBasket], ({ betObj, source }) =>
            source?.type === 'raceSim' ? `RacingSim-${source.mode}-${betObj.betType}` : ''
        );

        sendAdobeEvent({
            event: 'interaction',
            interaction: { eventID: 'betslip-sendbet-01' },
            content: {
                category: selectedBetProducts
                    .map((product) => {
                        switch (product) {
                            case 'HR':
                                return 'racing';
                            case 'FB':
                                return 'football';
                            case 'M6':
                                return 'marksix';
                            default:
                                return undefined;
                        }
                    })
                    .filter(Boolean)
                    .join(',')
            },
            user: {
                preference: Object.entries(betsGroupByRaceSimModeAndBetType)
                    .filter(([key]) => key.startsWith('RacingSim'))
                    .map(([key, value]) => `${key}:${value.length}`)
                    .join(',')
            }
        });
        glassboxCustomEvent('Place_Bet');
        sendTransactionPreviewBetSlipAdobeEvent();

        setIsShowPreviewInfo(true);
        setDisablePreviewConfirm(true);
        setTimeout((item) => {
            setDisablePreviewConfirm(false);
        }, 500);
    };

    const backBetlines = () => {
        setIsShowPreviewInfo(false);
        clearCounterOfferData();
        resetPanelAllupFn();
        if (window.globalConfig.BS_PREVIEW_DATA_REFRESH) {
            resetPreviewBetAcceptanceState();
        }
    };

    const clearCounterOfferData = () => {
        betBaskets[currentBasket]?.map((item) => {
            item.counterOfferAmountChange = false;
            item.counterOfferOddsChange = false;
            if (item.counterOfferData) {
                delete item['counterOfferData'];
            }
        });
    };

    const betConfirm = async () => {
        resetLoginTimeout(false);
        const sendBetResponse = await sendBetRequest(accessToken);
        if (sendBetResponse?.sendbet_status == '-2') {
            ssoExpired(sendBetResponse.sso_last_extend_error, true);
            return;
        }
        refreshToken()                           
        if (sendBetResponse?.delay_time_in_seconds) {
            // inplay delay
            setIsShowFTInplayDialog(true);
            const seqNo = sendBetResponse.delay_request_seq_no;
            const firstDelay = Number(sendBetResponse.delay_time_in_seconds);
            setFTInplayDialogDelay(firstDelay);
            setTimeout(async () => {
                const rsp = await sendBetRequest(accessToken, seqNo);
                resetLoginTimeout(false);
                if (rsp?.sendbet_error && rsp?.sendbet_error.indexOf('159') >= 0) {
                    const secondDelay = Number(sessionStorage.getItem('delay_retry_time') || 3);
                    setTimeout(async () => {
                        await sendBetRequest(accessToken, seqNo, true);
                        resetLoginTimeout(false);
                        setIsShowFTInplayDialog(false);
                        setFTInplayDialogDelay(0);
                    }, secondDelay * 1000);
                } else {
                    setIsShowFTInplayDialog(false);
                    setFTInplayDialogDelay(0);
                }
            }, firstDelay * 1000);
        }

        document.getElementById('betslip-panel').scrollTop = 0;
        glassboxCustomEvent('Send_Bet_Confirm');
    };

    const onClickCloseError = () => {
        setIsShowError(false);
    };

    const onClickSpeedbetTab = (index, e) => {
        if (isShowPreviewInfo) return;
        resetPanelAllupFn('all');
        setCurrentBasket(index);
    };

    const handleClickDone = (e) => {
        e?.stopPropagation?.()
        if (confirmationStatus.status === 'unknown' && confirmationStatus.accepted === 0) {
            const w = Math.min(800, window.innerWidth);
            const h = window.innerWidth > 768 ? 640 : window.innerHeight;
            const url = `/${lang}/betslip/acctstmt/transactionRecords`;
            MaxOnePopupWindow(false, url, '', w, h, 1, 1);
        }
        resetLoginTimeout(false);
        betDoneFn();

        if (sessionStorage.getItem('_OOSEngContent')) {
            sessionStorage.setItem('OOSEngContent', sessionStorage.getItem('_OOSEngContent'));
            sessionStorage.removeItem('_OOSEngContent');
        }
        if (sessionStorage.getItem('_OOSChiContent')) {
            sessionStorage.setItem('OOSChiContent', sessionStorage.getItem('_OOSChiContent'));
            sessionStorage.removeItem('_OOSChiContent');
        }
        if (sessionStorage.getItem('_OOSMsgId')) {
            sessionStorage.setItem('OOSMsgId', sessionStorage.getItem('_OOSMsgId'));
            sessionStorage.removeItem('_OOSMsgId');
            setLogoutUI(true, true);
        }
    };

    // const onBeforePrint = () => {
    //     const iframe = document.querySelector('#printWindow');
    //     iframe.contentWindow.document
    //         .querySelector('#divBetSlipNormal')
    //         .setAttribute('class', 'divBetSlipNormal-print');
    // };

    const getConfirmationTotalAmount = () => {
        let total = 0;
        betBaskets[currentBasket].forEach((item, index) => {
            total += Number(item.resultAmount || 0);
            /*
            if (item.resultCode === 0 && item.isCounterOffer == false) {
                if (item.prod === 'M6') {
                    const draw = item.betObj.multidraw || 1;
                    total += draw * item.unitBet * item.betObj.noOfBets;
                } else if (item.prod === 'FB') {
                    total += item.unitBet * (item.betObj.noOfBets || item.betObj.noOfComb);
                } else {
                    total += item.betObj.isFlexi
                        ? item.betObj.betTotal
                        : item.unitBet * (item.betObj.noOfBets || item.betObj.noOfComb);
                }
            }
            */
        });
        return total;
    };

    // const [balanceLoaded, setBalanceLoaded] = useState(false);
    const refreshBalance = async () => {
        if (sessionStorage.getItem('is_logon') == 1) {
            setBalance('...');
            const newValue = await getBalanceValue();
            if (newValue?.balanceStatus == '-2') {
                ssoExpired(newValue.sso_last_extend_error, true);
                return;
            }
            refreshToken();
            
            if (!isNaN(newValue?.balance) && newValue?.balanceStatus == '0') {
                setBalance(newValue.balance.toLocaleString(undefined, { minimumFractionDigits: 2 }));
            } else {
                setBalance('---');
            }
            resetLoginTimeout(false);
        }
        // setBalanceLoaded(true)
    };

    const [ssoLogoutNow, setSsoLogoutNow] = useState();

    window.handleResetLoginTimeoutChannelMessage = (callApi = true) => {
        if (window.globalConfig.NEW_LOGOUT_REMINDER_FLOW) {
            if (logoutReminderPopupState === LogoutReminderPopupType.closed && isLogonHigh()) {
                resetLoginTimeout(callApi);
            }
        } else {
            resetLoginTimeout(callApi);
        }
    };

    useBroadcastChannel('refreshBalance', setBalance);
    useBroadcastChannel('ssoLogoutNow', setSsoLogoutNow);
    useBroadcastChannel('resetLoginTimeout', window.handleResetLoginTimeoutChannelMessage);

    useSSOExpiryCheckOnFocus({
       enabled: window.globalConfig.NEW_LOGOUT_REMINDER_FLOW && ![LogoutReminderPopupType.timeout, LogoutReminderPopupType.passiveLogout].includes(logoutReminderPopupState),
       onExpired: ({isChannelMessage = false, isSessionExpiredError = false, onDisplayingSSOExpiryMessage} = {}) => {
            if (isChannelMessage) {
                setLogoutReminderPopupState(LogoutReminderPopupType.closed);
                return;
            }
            if (!isLogonHigh()) {
                setLogoutReminderPopupState(LogoutReminderPopupType.closed);
                return;
            };
            ssoExpired('', false);
            if (isSessionExpiredError) {
                setLogoutReminderPopupState(LogoutReminderPopupType.passiveLogout);
                onDisplayingSSOExpiryMessage();
            } else {
                setLogoutReminderPopupState(LogoutReminderPopupType.closed);
                setTimeout(() => {
                    window.alert(t(window.globalConfig.RETAIN_BETS_IN_BET_SLIP_ON_LOGOUT ? 'NEW_LB_BS_SSO_SIGN_IN_USER_CHANGED' : 'LB_BS_SSO_SIGN_IN_USER_CHANGED'));
                    onDisplayingSSOExpiryMessage();
                }, 0);
            }
       },
       refreshToken,
       throttleMs: 2000
    });

    useActivateUser({
        activateUser: () => setUserActive?.({
            checkEnabled: () => window.globalConfig.NEW_LOGOUT_REMINDER_FLOW && logoutReminderPopupState === LogoutReminderPopupType.closed && !isShowTandC && isLogonHigh(),
        })
    });

    useEffect(() => {
        if (ssoLogoutNow == 'ssoLogoutNow') {
            ssoExpired('', false);
            setSsoLogoutNow('');
        }
    }, [ssoLogoutNow]);
    
    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data?.type == 'betshare') {
                try { window.focus(); } catch { }
                if (window.isOpenAlert) {
                    return;
                }
                const { betType, betshareId, betslipMode, businessType, meetingDate, raceNo, venue, b_cid } = event.data.payload;
                if (betslipMode !== 'append') {
                    sessionStorage.setItem('betshareReset',1)
                }
                const newUrl = `/${i18n.language}/racing/${ betTypeConversionPage(betType)}/${ meetingDate}/${venue}/${ raceNo}?betshareId=${betshareId}&b_cid=${b_cid}`;
                navigate(newUrl, { replace: true });
            }
            if (event.data?.type === "betshare-ping") {
                window.opener?.postMessage(
                    { type: "betshare-pong" },
                    "*"
                );
            }
        };

        window.addEventListener("message", handleMessage);

        return () => {
        window.removeEventListener("message", handleMessage);
        };
    }, []);

    const hasHrOrFb = () => {
        return betBaskets[currentBasket].some((betLine) => {
            if (betLine.prod === 'FB' || betLine.prod === 'HR') {
                return true;
            }
        });
    };

    const checkIsEodAsync = async () => {
        await QueryConfig('channelParas', window.globalConfig.CHANNEL_PARA_URL);
        return setEodUi();
    };

    const checkIsEod = async () => {
        await QueryConfig('channelParas', window.globalConfig.CHANNEL_PARA_URL);
        return setEodUi();
    };

    const setEodUi = () => {
        if (isEoD()) {
            setLogoutUI(false, false);
            setPwd('');
            setLoginAccount('');
            return true;
        } else {
            return false;
        }
    };

    const getProduckCTAClassName = () => {
        const product = globalContext?.globalState?.product;
        switch (product) {
            case 'racing':
                return 'cta_hr';
            case 'football':
                return 'cta_fb';
            case 'marksix':
                return 'cta_m6';
            default:
                return 'cta_brand';
        }
    };

    const isPcardUser = () => {
        return (
            window.sessionStorage.getItem('PCardTier') != null &&
            window.sessionStorage.getItem('PCardTier') != '' &&
            window.sessionStorage.getItem('PCardTier') != 'NonPcard'
        );
    };

    const onClickEwalletLater = () => {
        setShowEwalletDialog(false);
        setLoginAccount('');
        setPwd('');
    };

    const onClickEwalletUpgrade = () => {
        setShowEwalletDialog(false);
        window.open(t('LB_BS_EWALLET_UPGRADE_URL'), '_blank');
        setLoginAccount('');
        setPwd('');
    };

    const getEodMessage = () => {
        let message =
            i18n.language === 'en' ? sessionStorage.getItem('OOSEngContent') : sessionStorage.getItem('OOSChiContent');
        if (message == null || message.length <= 0) {
            message = t('LB_BS_EOD');
        }
        return message;
    };

    const confirmDelSlip = () => {
        const flag = window.confirm(GetError('1304', i18n.language));
        if (flag) {
            clearCurrentBasket({ clearAll: true });
            glassboxCustomEvent('Clear_Slip');
            const deleteBetSlipAdobeEventData = getDeleteBetSlipAdobeEventData(betBaskets[currentBasket]);
            if (deleteBetSlipAdobeEventData) {
                sendAdobeEvent(deleteBetSlipAdobeEventData);
            }
        }
    };

    const handleCollapsibleControlClick = () => {
        if (isShowPreviewInfo || isShowConfirmation) {
            return;
        }
        setIsCollapse(!isCollapse);
    };

    const onClickTrustBrowser = async (trust) => {
        await FR_TurstBrowser(trust);
    };

    const handlePreviewBetAcceptanceClick = (id) => {
        const disable = sendBetAPILoading || disablePreviewConfirm;
        if (!disable) {
            onPreviewBetAcceptanceClick(id);
        }
    };

    const handleToggleAcceptAllChange = () => {
        const disable = sendBetAPILoading || disablePreviewConfirm;
        if (!disable) {
            toggleAcceptAllChange();
        }
    };

    const isDesktopCollapse = !isMobileSize && isCollapse;
    const canNextAddBetslip = isShowConfirmation && !confirmationStatus.isResendBet && confirmationStatus.status === 'accepted' && sessionStorage.getItem('confirmationStatus') === 'accepted'
    const canNextAddBetslipPc = !isMobileSize && canNextAddBetslip;

    const  checkFBBetLineCanDisplay = (betLine) => {
        if(window.globalConfig.BS_PREVIEW_DATA_REFRESH) {
            if (isShowPreviewInfo && betLine.betObj?.isStopSell && !betLine.isStopSellOnPreview || isShowPreviewInfo && betLine.onlyDisplayOnBetSlip) {
                return false;
            }
        } else {
            if (betLine.betObj?.isStopSell && isShowPreviewInfo) {  
                return false;
            }
        }
        return true;
    };

    return (
        <>
            {showOverlay && <div className="overlay" onClick={onClickOverlay2}/>}
            <div
                className={clsx('betslip-container', {
                    isEWinPage: isEWinPage(),
                    'betslip-collapse': isDesktopCollapse
                })}
                id="betslip-container"
            >
                <div
                    role="button"
                    tabIndex="0"
                    className="betslip-over-lay"
                    id="betslip-over-lay"
                    onClick={onClickOverlay}
                ></div>
	            {!accessToken && showLPEntry && (
                    <PcardPanel
                        isShowPcardPanel={isShowPcardPanel}
                        setIsShowPcardPanel={setIsShowPcardPanel}
                        setShowOverlay={setShowOverlay}
                        onClickOverlay={onClickOverlay}
                        isMobileSize={isMobileSize}
                        setIsCollapse={setIsCollapse}
                        setCwlPage={setCwlPage}
                    />
                )}
                <div id="divBetSlipNormal" ref={printRef}>
                    <div className={`eod ${isEoD() ? 'show' : ''}`}>
                        <div
                            className="eod-msg"
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(getEodMessage())
                            }}
                        />
                    </div>
                    <div
                        className={`login bsBgColor ${accessToken ? 'logonState' : ''} ${
                            isPcardUser() || isSpeedbet ? 'pcard' : ''
                        }`}
                        id="login"
                    >
                          {
                                loadingStepOne && <div className="loginLoading">
                                <LoginLoading ></LoginLoading>
                            </div>
                            }
                        <div className="login-account">
                            {!accessToken && (
                                <LoginAccountInfo
                                    pwd={pwd}
                                    loginAccount={loginAccount}
                                    onInputPwd={onInputPassword}
                                    onInputLoginAccount={onInputLoginAccount}
                                    loginInputFocus={loginInputFocus}
                                    loginInputBlur={loginInputBlur}
                                    onClickOverlay={onClickOverlay}
                                    goToFAQFn={goToFAQFn}
                                    handleClickSignIn={handleClickSignIn}
                                    isUsernameReadOnly={isUsernameReadOnly}
                                    isPwdReadOnly={isPwdReadOnly}
                                    APILoading={LoginAPILoading}
                                />
                            )}
                            {/* {accessToken && showLastLoginInfo && <LastLoginInfo onClickOverlay={onClickOverlay} goToFAQFn={goToFAQFn} />} */}
                            {accessToken && showUserInfo && (
                                <UserInfo
                                    onClickOverlay={onClickOverlay}
                                    handleClickLogout={handleClickLogout}
                                    userInfo={userInfo}
                                    balance={balance}
                                    refreshBalance={refreshBalance}
                                    isPcardUser={isPcardUser}
                                />
                            )}
                            <LogoutReminder
                                showReminder={showLogoutReminder}
                                onCancel={onCancelLogout}
                                onConfirm={onConfirmLogout}
                                isShowLogoutBetText={isShowLogoutBetText}
                            />
                            <LogoutSuccessMsg showMsg={showLogoutSucMsg} />
                        </div>
                        <LoginMenu
                            loginKey={accessToken}
                            loginOtherAccountLogout={loginOtherAccountLogout}
                            handleClickMenuItem={handleClickMenuItem}
                            isUsernameReadOnly={isUsernameReadOnly}
                            isSpeedbet={isSpeedbet}
                        />
                    </div>
                    {!isMobileSize && (
                        <div id="collapsible-control" className="expand" onClick={handleCollapsibleControlClick}>
                            <ArrowIcon />
                        </div>
                    )}
                    {isSpeedbet && !isShowPreviewInfo ? (
                        <div className="speedbet-tab">
                            {speedbetBasket.map((basket, index) => {
                                return [
                                    <div
                                        className={index == currentBasket ? 'active' : ''}
                                        onClick={(e) => onClickSpeedbetTab(index, e)}
                                    >
                                        {basket}{' '}
                                        {betBaskets[index]?.length > 0 ? '(' + betBaskets[index]?.length + ')' : ''}
                                    </div>
                                ];
                            })}
                        </div>
                    ) : null}
                    <ConfirmationHeader
                        isShow={isShowConfirmation}
                        sendBetTime={sendBetTime}
                        confirmationStatus={confirmationStatus}
                    />
                    <div
                        className={`dialogArea ${isShowTandC ? 'dialogAreaMBShow' : 'dialogAreaMBHide'} ${
                            isSpeedbet ? 'speedbetTandC' : ''
                        }`}
                    >
                        {isShowTandC && (
                            // <TandCComp
                            //     setShowOverlay={setShowOverlay}
                            //     showOverlay={showOverlay}
                            //     loginKey={accessToken}
                            //     closeCandTFn={closeCandTFn}
                            //     isLoadTNCText={isLoadTNCText}
                            //     setIsLoadTNCText={setIsLoadTNCText}
                            // />
                            <TCModal show={isShowTandC} isPriorityLoginRef={isPriorityLoginRef.current} menu={openCWL} setShowTCErrorPopup={setShowTCErrorPopup} setCwlPage={setCwlPage} cwlPage={cwlPage} onHide={() => closeTandCFn()} />
                        )}
                        {!window.globalConfig.NEW_LOGOUT_REMINDER_FLOW && isShowTODialog && (
                            <TimeOutWarnDialog
                                closeTOdialogFn={closeTOdialogFn}
                                resetLoginTimeout={resetLoginTimeout}
                                loginTimeoutRemind={loginTimeoutRemind}
                                calcTimeOutLogout={loginOtherAccountLogout}
                                sessionIdleTimeRef={sessionIdleTimeRef}
                                warningIdleTimeRef={warningIdleTimeRef}
                                warningIdleTimeRef2={warningIdleTimeRef2}
                            />
                        )}
                    </div>
                    <CustomScrollbars>
                        <div
                            className={`panel ${isShowPreviewInfo ? 'previewPanel' : ''} ${
                                isShowConfirmation ? 'confirmationPanel' : ''
                            } ${panelAllupObj?.uniqueMatchIdList?.length > 0 ? 'betslipPanelalupModel' : ''} `}
                            id="betslip-panel"
                        >
                            {loginIncorrectMsg && (
                                <LoginIncorrect
                                    messageCode={loginIncorrectMsg}
                                    onClose={closeLoginIncorrectMsg}
                                    setShowLoginLockPopup={setShowLoginLockPopup}
                                />
                            )}
                            {showEwalletDialog && (
                                <div className="login-answer-container">
                                    <div className="login-answer-title">{t('LB_BS_EWALLET_TITLE')}</div>
                                    <div className="login-answer-content">
                                        <div className="login-question">{t('LB_BS_EWALLET_DESC')}</div>
                                        <div className="button-box ">
                                            <div className="bsBgColor cta_brand" onClick={onClickEwalletLater}>
                                                {t('LB_BS_EWALLET_LATER')}
                                            </div>
                                            <div className="cta_yellow ewallet_upgrade" onClick={onClickEwalletUpgrade}>
                                                {t('LB_BS_EWALLET_UPGRADE')}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {isShowOTPAuth && (
                                <LoginOTP
                                    key={isShowOTPAuth.toString()} // Add a unique key to force re-render
                                    showMsg={isShowOTPAuth}
                                    onClickNext={onClickCheckOTP}
                                    invalidOTP={invalidOTP}
                                    setInvalidOTP={setInvalidOTP}
                                    otp={otp}
                                    setOtp={setOtp}
                                    setIsShowOTPAuth={setIsShowOTPAuth}
                                    onClickCancelOTP={onClickCancelOTP}
                                    getMobile={FR_GetMobile}
                                    resendOTP={FR_ResendOTP}
                                    isShowOTPToast={isShowOTPToast}
                                    setIsShowOTPToast = {setIsShowOTPToast}
                                    setShowLoginLockPopup = {setShowLoginLockPopup}
                                    isVoiceOTP = {isVoiceOTP}
                                    setIsVoiceOTP = {setIsVoiceOTP}
                                    verifyOtpLoading = {verifyOtpLoading}
                                />
                            )}
                            {isShowSecurityPinAuth && (
                                <SecurityPin
                                    key={isShowSecurityPinAuth.toString()} // Add a unique key to force re-render
                                    showMsg={isShowSecurityPinAuth}
                                    onClickNext={onClickCheckPin}
                                    invalidPIN={invalidPIN}
                                    setInvalidPIN={setInvalidPIN}
                                    pin={pin}
                                    setPin={setPin}
                                    onClickCancelSecurityPin={onClickCancelSecurityPin}
                                    setShowLoginLockPopup = {setShowLoginLockPopup}
                                    verifyPinLoading = {verifyPinLoading}
                                    setShowErrorPopup = {setShowErrorPopup}
                                />
                            )}
                            {isMissingMobile && (
                                <MissingMobile
                                    onClickCancelOTP={onClickCancelOTP}
                                    isMobile={isMobileSize}
                                    isMissingMobile={isMissingMobile}
                                />
                            )}
                            {showErrorPopup && (
                                <ErrorPopup
                                    errorType={showErrorPopup}
                                    handleClickCancel={onClickCancelErrorPopup}
                                    setShowErrorPopup={setShowErrorPopup}
                                />
                            )}
                            {showTCErrorPopup && (
                                <TCErrorPopup
                                    setShowTCErrorPopup={setShowTCErrorPopup}
                                />
                            )}
                            {showLoginLockPopup && (
                                <LoginErrorPopup
                                    // errorType={showErrorPopup}
                                    handleClickCancel={onClickCancelLoginLockPopup}
                                    setShowErrorPopup={setShowLoginLockPopup}
                                />
                            )}
                            {!window.globalConfig.NEW_LOGOUT_REMINDER_FLOW && isShowCSLogoutDialog && (
                                <ComingSoonLogoutDialog
                                    showMsg={isShowCSLogoutDialog}
                                    loginTimeoutRemind={loginTimeoutRemind}
                                    closeCSLogoutdialogFn={closeCSLogoutdialogFn}
                                    logoutStateFn={logoutStateFn}
                                    setPwd={setPwd}
                                    setLoginAccount={setLoginAccount}
                                    setIsUsernameReadOnly={setIsUsernameReadOnly}
                                    setIsPwdReadOnly={setIsPwdReadOnly}
                                    sessionIdleTimeRef={sessionIdleTimeRef}
                                    warningIdleTimeRef={warningIdleTimeRef}
                                    warningIdleTimeRef2={warningIdleTimeRef2}
                                />)}

                            {(isPassKeyRegConsent || isPassKeyRegSuccess) && (
                                <LoginPassKey
                                    showPassKeyRegConsent={isPassKeyRegConsent}
                                    showPassKeyRegSuccess={isPassKeyRegSuccess}
                                    handleClickCancel={onClickCancelPassKey}
                                    handleNext={onClickPassKeyBind}
                                    handleRegSuccess={onClickRegSuccess}
                                />
                            )}
                            {isShowPreviewInfo && !isShowConfirmation && (
                                <div className="preview-title">{t('LB_BETSLIP_PREVIEWBET')}</div>
                            )}
                            <BSPanelConfirmationTitle
                                printContent={printRef}
                                isShow={isShowConfirmation}
                                confirmationStatus={confirmationStatus}
                            />
                            {isShowError ? (
                                <div className="amount-error error-overlay" onClick={onClickCloseError}>
                                    <div>{t('LB_RBC_AMOUNTERROR')}</div>
                                    {/* <div className="switch-btn-icon open-btn-icon" onClick={onClickCloseError}></div> */}
                                </div>
                            ) : null}
                            {/* bet lines */}
                            {betBaskets[currentBasket].map((betLine, index) => {
                                if (betLine.prod === 'FB') {
                                    if (!checkFBBetLineCanDisplay(betLine)) {
                                        return null
                                    }

                                    return (
                                        <FBBetLineTemplate
                                            betLineData={betLine}
                                            key={betLine.id}
                                            panelAllupObj={panelAllupObj}
                                            panelAllupCheckFn={panelAllupCheckFn}
                                            setIsShowError={setIsShowError}
                                            isShowPreviewInfo={isShowPreviewInfo}
                                            isShowConfirmation={isShowConfirmation}
                                            loading={sendBetAPILoading || disablePreviewConfirm}
                                            changePreviewBetAcceptance={handlePreviewBetAcceptanceClick}
                                            betIndex={index + 1}
                                        />
                                    );
                                }
                                if (betLine.prod === 'M6') {
                                    return (
                                        <M6BetLineTemplate
                                            betLineData={betLine}
                                            key={betLine.id}
                                            panelAllupObj={panelAllupObj}
                                            isShowPreviewInfo={isShowPreviewInfo}
                                            isShowConfirmation={isShowConfirmation}
                                        />
                                    );
                                }
                                if (betLine.prod === 'HR') {
                                    return (
                                        <HRBetLineTemplate
                                            betLineData={betLine}
                                            key={betLine.id}
                                            panelAllupObj={panelAllupObj}
                                            panelAllupCheckFn={panelAllupCheckFn}
                                            setIsShowError={setIsShowError}
                                            isShowPreviewInfo={isShowPreviewInfo}
                                            isShowConfirmation={isShowConfirmation}
                                        />
                                    );
                                }
                            })}
                            {isShowConfirmation && <SurveyInBetSlip />}
                        </div>
                    </CustomScrollbars>
                    <EarlySettlementShortcutNavigate
                        betData={betBaskets[currentBasket]}
                        isShowConfirmation={isShowConfirmation}
                    />
                    {!isShowPreviewInfo && (
                        <div className="control">
                            {
                                /* (!panelAllupObj || panelAllupObj?.uniqueMatchIdList?.length < 1) && */ <div className="add-slip">
                                    <div>
                                        <div data-testid='bet_totalNumberOfBets_label'>{t('LB_BS_TOTAL_NO_OF_BETS')}</div>
                                        <div data-testid='bet_totalNumberOfBets_value' className="money">
                                            {textFormatAmountFn(getBetTotal()?.totalBet, 0) || 0}
                                        </div>
                                    </div>
                                    <div>
                                        <div  data-testid='bet_totalAmount_label'>{t('LB_BS_Total_AMOUNT')}</div>
                                        <div  data-testid='bet_totalAmount_value' className="money">
                                            ${textFormatAmountFn(getBetTotal()?.totalAmount, 0) || 0}
                                        </div>
                                    </div>
                                    <div className={`betSlipBottomBtnArea ${cashoutIP}`}>
                                        <div>
                                            <button
                                                data-testid='bet_clean_button'
                                                aria-label={t('LB_BS_AS_DETELE_ALL_BETS')}
                                                disabled={!hasBetlines()}
                                                className={`delete background2 ${getProduckCTAClassName()}`}
                                                onClick={() => {
                                                    confirmDelSlip();
                                                }}
                                            ></button>
                                        </div>
                                        <div>
                                            <button
                                                disabled={!canSendBet(betBaskets)}
                                                className="send background2 cta_yellow"
                                                onClick={gotoPreview}
                                                data-testid={'bet_placeBet_button'}
                                            >
                                                {t('LB_SEND_BET')}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            }
                            {hasHrOrFb() && !isDesktopCollapse && (
                                <PanelAlupTemplate
                                    panelAllupObj={panelAllupObj}
                                    panelAllupData={panelAllupData}
                                    setPanelAllupData={setPanelAllupData}
                                    resetPanelAllupFn={resetPanelAllupFn}
                                    cashoutIP={cashoutIP}
                                />
                            )}
                        </div>
                    )}
                    {
                        showAcceptAllCheckbox && (
                            <OddsUpdatedAcceptCheckbox
                                label={t('LB_BS_BET_ACCEPT_ALL')}
                                description={t('LB_BS_BET_SOME_ODDS_UPDATED')}
                                className="accept-all-odds-updated"
                                checked={isAcceptAllChange}
                                loading={sendBetAPILoading || disablePreviewConfirm}
                                onChange={handleToggleAcceptAllChange}
                            />
                        )
                    }
                    {isShowPreviewInfo && (
                        <div className={`preview-bot-area ${isMobileSize ? 'preview-bot-area-mobile' : 'preview-bot-area-pc'} ${canNextAddBetslip ? 'can-click-area' : ''} preview-bot-area`} onClick={
                            (e)=>{
                                    canNextAddBetslip &&  
                                    handleClickDone(e)
                                }
                            }>
                            <div className="preview-dfjs preview-bot">
                                <div className="font13">{t('LB_BS_Total_AMOUNT')}</div>
                                {isShowConfirmation ? (
                                    <div className="font15">
                                        ${textFormatAmountFn(getConfirmationTotalAmount() || 0, 0, false)}
                                    </div>
                                ) : (
                                    <div className="font15">
                                        ${textFormatAmountFn(getBetTotal()?.totalAmount || 0, 0, false)}
                                    </div>
                                )}
                            </div>
                            {isShowConfirmation ? (
                                <div
                                    className={`betslip-confirmation-done ${
                                        confirmationStatus.isResendBet ? 'resendBetBtn' : ''
                                    }`}
                                >
                                    {confirmationStatus.isResendBet ? (
                                        <>
                                            <ResendDoneDialog onClickConfirm={handleClickDone} />
                                            <button
                                                className={`confirm cta_yellow  ${disabledResendBtn ? 'disabled' : ''}`}
                                                onClick={handleClickResendBtn}
                                                disabled={disabledResendBtn}
                                            >
                                                {t('LB_BS_RESENDBET_SEND')}
                                            </button>
                                        </>
                                    ) : (
                                        <button
                                            className={`${
                                                confirmationStatus.status === 'unknown' &&
                                                confirmationStatus.accepted === 0
                                                    ? 'confirm_tr'
                                                    : 'confirm'
                                            } ${getProduckCTAClassName()} ${
                                                confirmationStatus.isResendBet && disabledResendBtn ? 'disabled' : ''
                                            } ${
                                                canNextAddBetslipPc ? 'canNextAddBetslip' : ''
                                            }`}
                                            onClick={(e) => handleClickDone(e)}
                                            disabled={confirmationStatus.isResendBet && disabledResendBtn}
                                            id={'betslip_finish_button'}
                                        >
                                            {confirmationStatus.status === 'unknown' && confirmationStatus.accepted == 0
                                                ? t('LB_BETSLIP_TR')
                                                : canNextAddBetslipPc ? <div className={"canNextAddBetslipText"}>
                                                    <span className='BETTING_PROCESS_COMPLETED'>{t('BETTING_PROCESS_COMPLETED')} </span>
                                                    <span className='LB_BS_CAN_ADD_BETSLIP'>{t('LB_BS_CAN_ADD_BETSLIP')} </span>
                                                </div> : t('LB_BETSLIP_DONE')}
                                        </button>
                                    )}
                                </div>
                            ) : (
                                <div className="preview-dfjs">
                                    <div>
                                        <button
                                            className={`back ${getProduckCTAClassName()} background2`}
                                            onClick={backBetlines}
                                            disabled={sendBetAPILoading}
                                        >
                                            {t('LB_BETSLIP_PREVIEWBACK')}
                                        </button>
                                    </div>
                                    <div>
                                        <button
                                            className="confirm cta_yellow"
                                            disabled={
                                                sendBetAPILoading ||
                                                disablePreviewConfirm ||
                                                (window.globalConfig.BS_PREVIEW_DATA_REFRESH &&
                                                    (getNumberOfBetlines(isPreviewPage) ?? 0) === 0)
                                            }
                                            onClick={betConfirm}
                                        >
                                            {t('LB_BETSLIP_PREVIEWCONFIRM')}
                                            {window.globalConfig.BS_PREVIEW_DATA_REFRESH && ` (${getNumberOfBetlines(isPreviewPage) ?? 0})`}
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                    {isShowFTInplayDialog && FTInplayDialogDelay && !isDesktopCollapse && (
                        <FootballInplayMsgDialog
                            setIsShowFTInplayDialog={setIsShowFTInplayDialog}
                            FTInplayDialogDelay={FTInplayDialogDelay}
                        />
                    )}
                    {isShowTrustBrowser && !isDesktopCollapse && (
                        <TrustBrowser 
                            showMsg={true} 
                            FR_TurstBrowser={onClickTrustBrowser} 
                            isShowTrustBrowser={isShowTrustBrowser} 
                            setIsShowTrustBrowser={setIsShowTrustBrowser} 
                            checkIsEod = {checkIsEod} 
                            isVoiceOTP = {isVoiceOTP}
                            setLoginIncorrectMsg = {setLoginIncorrectMsg}
                            isSecurityPin = {isSecurityPin}
                        />
                    )}
                </div>
                <audio
                    style={{ width: 50 }}
                    className="bgMusic"
                    src={bgMusic}
                    controls="controls"
                    preload="true"
                    id="music1"
                    type="audio/wav"
                ></audio>
                {
                    window.globalConfig.NEW_LOGOUT_REMINDER_FLOW && (
                        <LogoutReminderPopup
                            logoutReminderPopupState={logoutReminderPopupState}
                            resetLoginTimeout={resetLoginTimeout}
                            calcTimeOutLogout={loginOtherAccountLogout}
                            sessionIdleTimeRef={sessionIdleTimeRef}
                            highSecurityLogout={highSecurityLogout}
                            onClose={handleLogoutReminderPopupClose}
                        />
                    )
                }
            </div>
        </>
    );
};
export default BetSlip;
